import { render, staticRenderFns } from "./TransportationChangeLogsDetailsView.vue?vue&type=template&id=1cb2886f&scoped=true"
import script from "./TransportationChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./TransportationChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./TransportationChangeLogsDetailsView.vue?vue&type=style&index=0&id=1cb2886f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb2886f",
  null
  
)

export default component.exports